import { useMutation } from '@tanstack/react-query';

import type { BusinessDirectionMutationResponse } from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useBusinessDirectionActionMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<BusinessDirectionMutationResponse>({
        method: 'PUT',
        url,
      }),
  });

export const useReorderBusinessDirectionMutation = (url: string) =>
  useMutation({
    mutationFn: (ids: number[]) =>
      HttpClient.request<BusinessDirectionMutationResponse>({
        method: 'PUT',
        url,
        data: { ids },
      }),
  });
